import { useEffect, useState } from "react";

export function useReaderPanels({ isVisible, isCompactLayout }) {
  const [showVoiceTuning, setShowVoiceTuning] = useState(false);
  const [showAudioKeyGuide, setShowAudioKeyGuide] = useState(false);
  const [showTimerMenu, setShowTimerMenu] = useState(false);
  const [showChapterPicker, setShowChapterPicker] = useState(false);
  const [showUnderstandLanguageMenu, setShowUnderstandLanguageMenu] = useState(false);
  const [showQueuePanel, setShowQueuePanel] = useState(false);
  const [timerMenuDirection, setTimerMenuDirection] = useState("down");
  const [activeUtilitySheet, setActiveUtilitySheet] = useState("");

  useEffect(() => {
    if (!isVisible && activeUtilitySheet) {
      setActiveUtilitySheet("");
    }
  }, [activeUtilitySheet, isVisible]);

  useEffect(() => {
    if (!isVisible && showChapterPicker) {
      setShowChapterPicker(false);
    }
  }, [isVisible, showChapterPicker]);

  useEffect(() => {
    if (!isVisible && showTimerMenu) {
      setShowTimerMenu(false);
    }
  }, [isVisible, showTimerMenu]);

  useEffect(() => {
    if (!isVisible && showUnderstandLanguageMenu) {
      setShowUnderstandLanguageMenu(false);
    }
  }, [isVisible, showUnderstandLanguageMenu]);

  useEffect(() => {
    if (!isCompactLayout && activeUtilitySheet) {
      setActiveUtilitySheet("");
    }
  }, [activeUtilitySheet, isCompactLayout]);

  useEffect(() => {
    if (isCompactLayout && showChapterPicker) {
      setShowChapterPicker(false);
    }
  }, [isCompactLayout, showChapterPicker]);

  return {
    showVoiceTuning,
    setShowVoiceTuning,
    showAudioKeyGuide,
    setShowAudioKeyGuide,
    showTimerMenu,
    setShowTimerMenu,
    showChapterPicker,
    setShowChapterPicker,
    showUnderstandLanguageMenu,
    setShowUnderstandLanguageMenu,
    showQueuePanel,
    setShowQueuePanel,
    timerMenuDirection,
    setTimerMenuDirection,
    activeUtilitySheet,
    setActiveUtilitySheet
  };
}
